/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductSortimentCreateRequest } from '../../models/product-sortiment-create-request';
import { ProductSortimentCreateResponse } from '../../models/product-sortiment-create-response';

export interface AddProductToSortiment$Params {
      body: ProductSortimentCreateRequest
}

export function addProductToSortiment(http: HttpClient, rootUrl: string, params: AddProductToSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductSortimentCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, addProductToSortiment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductSortimentCreateResponse>;
    })
  );
}

addProductToSortiment.PATH = '/sortiments/products';
